import type { ReactNode } from 'react';

/// The two view atoms every screen is built from, matching the native apps.

export function Card({ title, action, children, wide }: {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <section className={`card${wide ? ' card--wide' : ''}`}>
      {(title || action) && (
        <header className="card__head">
          {title && <h2>{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

export function Row({ label, value, tone }: {
  label: string;
  value: string;
  tone?: 'good' | 'warn';
}) {
  return (
    <div className="row">
      <span className="row__label">{label}</span>
      <span className={`row__value${tone ? ` row__value--${tone}` : ''}`}>{value}</span>
    </div>
  );
}

export function Bar({ fraction }: { fraction: number }) {
  const clamped = Math.max(0, Math.min(1, Number.isFinite(fraction) ? fraction : 0));
  return (
    <div className="bar" role="progressbar" aria-valuenow={Math.round(clamped * 100)}>
      <div className="bar__fill" style={{ width: `${clamped * 100}%` }} />
    </div>
  );
}
